import { Redirect, Route, useLocation } from "react-router-dom";

interface ProtectedRouteProps {
	ProtectedComponent: React.ComponentType<any>;
	GuestComponent?: React.ComponentType<any>;
	path: string;
	isAuthenticated: boolean;
	exact?: boolean;
	componentProps?: any;
}

//TODO:Performance Optimization here for limiting the times it renders the route again.
//TODO:Animations

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
	ProtectedComponent,
	GuestComponent,
	isAuthenticated,
	path,
	componentProps,
}) => {
	const location = useLocation();

	// Extract UUID from the URL if present
	const urlParams = new URLSearchParams(location.search);
	const uuid = urlParams.get("uuid");

	return (
		<Route
			path={path}
			exact
			render={() => {
				// Case 1: User is authenticated - show protected component
				if (isAuthenticated) {
					return <ProtectedComponent {...componentProps} />;
				}

				// Case 2: URL has valid UUID - show guest component
				if (uuid && GuestComponent) {
					return <GuestComponent uuid={uuid} {...componentProps} />;
				}

				// Case 3: Neither authenticated nor valid UUID - redirect to login
				return (
					<Redirect
						to={{
							pathname: "/login",
							state: { from: location.pathname },
						}}
					/>
				);
			}}
		/>
	);
};
